import { render, staticRenderFns } from "./GetCustomersLogsAndProductsSubComponent.vue?vue&type=template&id=0bb03858&scoped=true&"
import script from "./GetCustomersLogsAndProductsSubComponent.vue?vue&type=script&lang=js&"
export * from "./GetCustomersLogsAndProductsSubComponent.vue?vue&type=script&lang=js&"
import style0 from "./GetCustomersLogsAndProductsSubComponent.vue?vue&type=style&index=0&id=0bb03858&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb03858",
  null
  
)

export default component.exports